export type RelationData = {
    label: string,
    value: string
}
export const relations: RelationData[] = [
    {
        label: 'Optional',
        value: ''
    },
    {
        label: 'Self',
        value: 'self'
    },
    {
        label: 'Child',
        value: 'child'
    },
    {
        label: 'Spouse',
        value: 'spouse'
    },
    {
        label: 'Other Dependent',
        value: 'other_dependent'
    }
]